import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/school/base"

const school = {
  getTreeSysRegionList() {
    return axios.get(pre + `/getTreeSysRegionList`);
  },
  schoolListPage(pageSize, limit, keyWord) {
    return axios.get(pre + `/schoolListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
        }
    });
  },
  schoolAllList() {
    return axios.get(pre + `/schoolList`);
  },

  schoolInfo(id) {
    return axios.get(pre + `/schoolInfo`, {params: {id: id}});
  },
  schoolSave(params) {
    return axios.post(pre + `/schoolSave`, qs.stringify(params));
  },
  schoolDelete(id) {
    return axios.delete(pre + `/schoolDelete`, {params: {id: id}});
  },

  gradeList(schoolId) {
    return axios.get(pre + `/gradeList`, {
      params:
        {
          schoolId: schoolId
        }
    });
  },

  gradeInfo(id) {
    return axios.get(pre + `/gradeInfo`, {params: {id: id}});
  },
  gradeSave(params) {
    return axios.post(pre + `/gradeSave`, qs.stringify(params));
  },
  gradeDelete(id) {
    return axios.delete(pre + `/gradeDelete`, {params: {id: id}});
  },
}
export default school;



// WEBPACK FOOTER //
// ./src/api/config/school.js